import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./PatientItem.style";

function PatientItem({
  patient,
  added
}) {

  const { t, i18n: { language } } = useTranslation("global");

  return (
    <S.DoctorItem
      active={added}
    >
      <i className={`device-addition-icon icon ${added ? "zaia-i-remove" : "zaia-i-add-1"}`}></i>
      <div className="device-info">
        <div className="device-info__name">
          {patient?.name} {patient?.lastname}
        </div>
      </div>
    </S.DoctorItem>
  );
}




export default PatientItem;
